// AnnotationLibraryWrapper.js

import React, { useState } from 'react';
import {
  Box,
  Button,
  Collapse,
  useMediaQuery,
  useTheme,
  Drawer,
  Fab,
} from '@mui/material';
import AnnotationLibrary from './AnnotationLibrary';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const AnnotationLibraryWrapper = ({ onSelectAnnotation }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [open, setOpen] = useState(!isMobile);
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleOpen = () => setOpen((prev) => !prev);

  if (isMobile) {
    return (
      <>
        <Fab
          color="primary"
          sx={{ position: 'fixed', bottom: 16, right: 16, zIndex: 1000 }}
          onClick={() => setDrawerOpen(true)}
        >
          <MenuBookIcon />
        </Fab>

        <Drawer
          anchor="bottom"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          ModalProps={{ keepMounted: true }}
        >
          <Box sx={{ p: 2 }}>
            <AnnotationLibrary onSelectAnnotation={onSelectAnnotation} />
          </Box>
        </Drawer>
      </>
    );
  }

  return (
    <Box sx={{ mb: 2 }}>
      <Button
        variant="outlined"
        onClick={toggleOpen}
        sx={{ mb: 1, width: '100%' }}
      >
        {open ? 'Hide Annotation Library' : 'Show Annotation Library'}
      </Button>
      <Collapse in={open}>
        <AnnotationLibrary onSelectAnnotation={onSelectAnnotation} />
      </Collapse>
    </Box>
  );
};

export default AnnotationLibraryWrapper;